import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { ActivityType } from "@app/enums";
import { TrainingService } from "@shared/services/legacy/training.service";
import { map } from "rxjs";
import { ApiService } from "src/services/api.service";
import { CompanyService } from "src/services/company.service";

export const hasTrainingAccess: CanActivateFn = () => {
	const companyService = inject(CompanyService);
	const router = inject(Router);

	const hasPersonalizedTrainingAccess =
		companyService.hasPersonalizedTrainingAccess();

	if (!hasPersonalizedTrainingAccess) {
		router.navigate(["/home"]);
		return false;
	}

	return true;
};

export const hasDoneTrainingSurvey: CanActivateFn = () => {
	const apiService = inject(ApiService);
	const trainingService = inject(TrainingService);
	const router = inject(Router);

	return trainingService.getPersonalizedTrainingSurveyResponse().pipe(
		map((response) => {
			if (
				!response.SurveyResponse?.Id ||
				!response.SurveyResponse?.TrainingSelectionId ||
				!response.SurveyResponse?.TimeRangeId
			) {
				router.navigate(["/training/survey"]);
				return false;
			}
			apiService.CreateActivityLog(
				ActivityType.OpenPersonalizedTraining,
				response.SurveyResponse.Id,
			);
			return true;
		}),
	);
};
